<template>
  <div
    id="J_Interests"
    class="interests"
  >
    <h3 class="interests-title">
      <span
        v-if="hasTitle"
        class="left-title"
      >{{ title }}</span>
      <div
        v-if="viewModel.moreShow"
        class="fr"
        @click="showMore"
      >
        <a
          v-if="!viewModel.moreShow"
          class="more"
        >更多特权<i /></a>
        <a
          v-else
          class="more"
          :style="{ textIndent: '20px' }"
        >
          收起
          <i
            :style="{
              backgroundImage: `url(${require('@/assets/images/twoTop.png')})`
            }"
          />
        </a>
      </div>
    </h3>
    <ul class="interests-list clearfix nondraggable is-member">
      <li
        v-for="item in iconListShow"
        :key="item.title"
        class="interests-item"
        :class="{ 'interests-item-no-right': item.noRight }"
        :style="{ cursor: viewModel.isMember && !item.method ? 'default' : 'pointer' }"
        @click="handleClickIconItem(item)"
      >
        <div
          class="item-pic"
          :class="
            `${item.className} ${item.noRight ? item.className + '-grey' : ''}`
          "
        />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="item.title" />
        <div
          v-if="item.alias === '121svr'"
          class="sprite-icon sprite-icon-1v1-tip tip"
        />
        <!-- 进度条 -->
        <ProgressBar v-show="item.showProgress && item.isProgressBar" />
      </li>
    </ul>
    <DubaInterests v-if="hasDubaInterests" />
    <slot />
    <template v-if="hasSpread">
      <SpreadItem
        v-for="(item, index) in interestsIntroShow"
        :key="index"
        :class="`item spread-center spread-item${item.iconItem}`"
        :content="item"
        :img-position="index % 2 === 0 ? 'right' : 'left'"
      >
        <div slot="btn-w">
          <!-- 有type的按钮特殊处理 -->
          <div
            v-if="
              item.method &&
                !item.type &&
                (!item.needPrivilege ||
                (item.needPrivilege &&
                viewModel.loginStatus &&
                viewModel.permissionList.indexOf(item.alias) !== -1))
            "
            class="spread-btn fl"
            style="margin-right: 15px"
            @click="item.method"
          >
            {{ item.btnTxt || '立即体验' }}
          </div>
          <div
            v-if="item.alias === '121svr'"
            class="desc-tip"
          />
        </div>
      </SpreadItem>
    </template>
    <div
      v-if="viewModel.hasUsedTipShow"
      class="tips-1v1-hasused"
    >
      <div
        class="close"
        @click="viewModel.hasUsedTipShow = false"
      />
      <p>本月会员免费机会已用完，前往帮助页寻求帮助吧！</p>
      <div
        class="btn"
        @click="toExaminationHome"
      >
        去看看
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/client/'
import SpreadItem from '@/components/common/SpreadItem'
import ProgressBar from '@/components/common/ProgressBar'
import { scrollTo } from '@/utils/scroll'
import { getPrivilegeInfoApi } from '@/api/user'
import { DOMAIN_RELATED } from '@/config/dataMap'
import DubaInterests from '@/components/DubaInterests'

import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'
import { UserService } from '@/services/user.service'
import { ToastService } from '@/services/toast.service'
import { EventBusService } from '@/services/event-bus.service'
import { CustomerService } from '@/services/customer.service'

import { defineComponent, onMounted, onUnmounted, reactive, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'Interests',
  components: {
    SpreadItem,
    ProgressBar,
    DubaInterests
  },
  props: {
    hasChild: Boolean,

    /** 有毒霸权益 */
    hasDubaInterests: {
      type: Boolean,
      default: true
    },

    /** 有底部的介绍 */
    hasSpread: {
      type: Boolean,
      default: true
    },

    /** 展示标题 */
    hasTitle: {
      type: Boolean,
      default: true
    },

    /** 展示卡片且修改位置 */
    showAndPositionCards: {
      type: Array,
      default: () => [],
    }
  },

  setup (props, context) {
    const { emit } = context
    const injector = useReflectiveInjector()
    const user = injector.get(UserService)
    const toast = injector.get(ToastService)
    const eventBus = injector.get(EventBusService)
    const customer = injector.get(CustomerService)

    const iconList = [
      {
        alias: 'pdf_to_word',
        className: 'item22',
        title: '不限大小次数',
        showProgress: true,
        isProgressBar: false,
        report: 20,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_to_word',
        className: 'item23',
        title: '扫描件转换',
        showProgress: true,
        isProgressBar: false,
        report: 21,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_to_word',
        className: 'item24',
        title: 'CAD转换',
        showProgress: true,
        isProgressBar: false,
        report: 22,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_to_word',
        className: 'item25',
        title: 'PDF无损压缩',
        showProgress: true,
        isProgressBar: false,
        report: 23,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_to_word',
        className: 'item26',
        title: '图片PDF互转',
        showProgress: true,
        isProgressBar: false,
        report: 24,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_to_word',
        className: 'item27',
        title: '图片OCR',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord
      },
      {
        alias: 'pdf_edit',
        className: 'item28',
        title: 'PDF编辑',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item29',
        title: 'PDF插入文字',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item30',
        title: 'PDF插入图片',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item31',
        title: 'PDF擦除',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item32',
        title: 'OCR文字扫描',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item33',
        title: 'PDF去掉水印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item34',
        title: '批量<br/>一键打印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item35',
        title: '发票报销<br/>打印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word'
      },
      {
        alias: 'pdf_edit',
        className: 'item3',
        title: 'VIP客服',
        report: 21,
        type: 'vip',
        method: openVipService
      },
      {
        alias: 'pdf_edit',
        className: 'item36',
        title: '全文翻译',
        showProgress: true,
        isProgressBar: false,
        report: 28,
        type: 'pdf2word',
        method: openTranslate
      }
    ]
    const kismainName = 'kismain.exe'
    const viewModel = reactive({
      loginStatus: user.loginStatus,
      isMember: user.isMember,
      isPdfMember: user.isPdfMember,
      isPdfLifeMember: user.isPdfLifeMember,
      privilege: user.privilege,
      token: user.token,
      openId: user.openId,
      moreShow: false,
      hasUsedTipShow: false,
      baseSortIconList: null,
      vip_version: '',
      permissionList: [],
      interestsIntro: [
        {
          title: 'PDF转换',
          iconItem: 7,
          pic_url: require('@/assets/images/pdf.png'),
          desc: [
            '多格式转换，转Word/转Excel/转PPT',
            '高效办公，一键批量转换',
            '无限制，超大文档任意转'
          ],
          key_name: 'pdf2word',
          btnTxt: '立即体验',
          method: openPdfToWord
        }
      ],
      iconList: iconList
    })

    const subUserInfoChanged = user.onUserInfoChanged.subscribe(() => {
      viewModel.loginStatus = user.loginStatus
      viewModel.isMember = user.isMember
      viewModel.isPdfMember = user.isPdfMember
      viewModel.isPdfLifeMember = user.isPdfLifeMember
      viewModel.privilege = user.privilege
      viewModel.token = user.token
      viewModel.openId = user.openId
    })

    const hasPrivilege = computed(() => viewModel.isMember || viewModel.isPdfMember)
    const title = computed(() => {
      if (viewModel.loginStatus && hasPrivilege.value) {
        return '我的特权：'
      }
      return context.root.$route.name === 'Home' ? '会员享有以下特权：' : 'PDF会员享有以下特权：'
    })

    const isVip = computed(() => viewModel.isMember || viewModel.isPdfMember || viewModel.isPdfLifeMember)
    const interestsIntroShow = computed(() => viewModel.interestsIntro.filter(item => !item.hide))
    const iconListShow = computed(() => {
      const iconList = viewModel.iconList.filter(item => !item.hide)
      let classNames = props.showAndPositionCards
      const transformList = []

      // 非全文翻译页面都不要展示全文翻译卡片
      const routeName = context.root.$route.name
      if (routeName !== 'Translate') {
        classNames = iconList.map(e => e.className != 'item36' && e.className)
      }

      if (classNames.length === 0) {
        return iconList
      }

      iconList.forEach(e => {
        const index = classNames.indexOf(e.className)
        if (index > -1) {
          transformList[index] = e
        }
      })

      return transformList
    })

    eventBus.$on('logout', () => {
      resumeIconList()
    })

    eventBus.$on('paysuccess', () => {
      sortIconList()
    })

    eventBus.$on('sortIconList', () => {
      sortIconList()
    })

    onMounted(() => {
      checkVipVersion()
      sortIconList()
      init()
    })

    onUnmounted(() => {
      subUserInfoChanged.unsubscribe()
    })

    function init () {
      let { scroll } = context.root.$route.query
      scroll = parseInt(scroll || 0)
      if (scroll && viewModel.iconList[scroll]) {
        scrollToPosition(viewModel.iconList[scroll])
      }
      reportPerformace()
    }
    function login () {
      client.common.API.userLogin()
    }

    function tipsShow () {
      if (!viewModel.loginStatus) {
        login()
        return
      }

      if (viewModel.isMember) {
        window.open('https://url.cn/5f9aYiA?_type=wpa&qidian=true')
      } else {
        toast.show('该权益为会员专享')
      }
      client.home.REPORT.reportHomeOperate({ main_click: 6, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    function openRecovery () {
      client.common.API.openRecovery()
      if (props.hasChild) {
        return emit('report', 34)
      }
      client.home.REPORT.reportHomeOperate({ main_click: 5, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    /** 打开vip客服 */
    async function openVipService () {
      const url = await customer.getContactCustomerServiceUrl('vip-center')
      if (url) {
        window.open(url)
      }
    }

    function client_openKisProcess (params) {
      client.common.API.client_openKisProcess(params)
    }

    function client_open_vip_box (params) {
      client.common.API.client_open_vip_box(params)
    }

    function openPureNoAds () {
      client_openKisProcess({
        name: 'kpurenoad.exe',
        arg: {
          vipfrom: '3012',
          puresource: '2'
        }
      })
    }

    function openPdfToWord () {
      client_openKisProcess({
        name: 'pdfconverter.exe',
        arg: {
          vipfrom: '6001',
          from: '3'
        }
      })

      if (props.hasChild) {
        return emit('report', 35)
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 14,
        user_login: viewModel.loginStatus ? 1 : 2
      })
    }

    /** 打开全文翻译 */
    function openTranslate () {
      client_openKisProcess({
        name: 'fphelper.exe',
        arg: {
          tlbox_mainexe: 'translation.exe',
          tlbox_secname: 'pdf_translation',
          pid: '3',
          other: '/tlbox_download_run /medium_permission',
          dlbox_params: '/from:4'
        }
      })
    }

    function showMore () {
      viewModel.moreShow = !viewModel.moreShow
      if (props.hasChild) {
        return
      }
      client.home.REPORT.reportHomeOperate({ main_click: 15, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    function toExamination () {
      context.root.$router.push('/examination')
    }

    /** 打开浏览器主页修复 */
    function openHomepageFix () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:homeprotect /from:2'
      })
    }

    /** 调起文档修复 */
    function openDocFix () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:docfix /from:6'
      })

      client.home.REPORT.reportHomeOperate({ main_click: 58, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    /** 调起文档卫士 */
    function openDocProtect () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:office_protect /from:7'
      })

      client.home.REPORT.reportHomeOperate({ main_click: 59, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    function openPurificationWindow () {
      client_openKisProcess({
        name: 'ksoftpurifier.exe',
        arg: {}
      })

      if (props.hasChild) {
        return emit('report', 37)
      }

      client.home.REPORT.reportHomeOperate({ main_click: 26, user_login: viewModel.loginStatus ? 1 : 2 })
    }

    function openDocProtectWindow () {
      client.common.API.callClient({ type: 'openDocProtectWindow', query: {} })
      if (props.hasChild) {
        return emit('report', 38)
      }

      client.home.REPORT.reportHomeOperate({
        main_click: 27,
        user_login: viewModel.loginStatus ? 1 : 2
      })
    }

    function handleClickIconItem (item) {
      const itemList = ['item3', 'item36'] // 全文翻译、vip客服判断逻辑不一样
      if (itemList.includes(item?.className)) {
        handleUnlikeIconItem(item)
        return
      }

      // 会员且有函数直接调起相应功能
      if ((viewModel.isMember || item.allowClick) && item.method) {
        item.isProgressBar = true

        setTimeout(() => {
          item.isProgressBar = false
        }, item.progressTime || 2000)
        item.method()
        return
      }

      if (item.notMemberMethod) {
        item.notMemberMethod()
        return
      }

      scrollToPosition(item)
    }

    /** 例外的图标处理逻辑不一样 */
    function handleUnlikeIconItem (item) {
      if ((isVip.value || item.allowClick) && item.method) {
        item.isProgressBar = true
        setTimeout(() => {
          item.isProgressBar = false
        }, item.progressTime || 2000)
        item.method()
        return
      }

      scrollToPosition(item)
    }

    function scrollToPosition (item) {
      client.home.REPORT.reportHomeOperate({
        main_click: item.report,
        user_login: viewModel.loginStatus ? 1 : 2
      })

      let className = item.className
      className = 'item7'
      className = `spread-${className}`
      const _dom = document.querySelector(`.${className}`)

      if (!_dom) {
        return
      }

      const scrollTop = _dom.offsetTop
      const _parent = document.querySelector('.wrap_scroll')
      scrollTo(scrollTop, 200, _parent)
    }

    async function checkVipVersion () {
      const data = await client.common.API.client_getVipVersion()
      viewModel.vip_version = data.result
    }

    // 判断是否可以体检 未登录-去登陆  不满足体检条件-弹窗

    function checkExamPrivilege () {
      client.home.REPORT.reportHomeOperate({
        main_click: 16,
        user_login: viewModel.loginStatus ? 1 : 2
      })

      // 版本号判断, 老版本走老逻辑
      if (viewModel.vip_version < 17) {
        oldCheckExamPrivilege()
      } else {
        if (viewModel.privilege) {
          // 查看会员权限
          if ((viewModel.isMember) && viewModel.privilege.privilege_status === 0) {
            context.root.$router.push('/examination')
            return
          }

          if ((viewModel.isMember) && viewModel.privilege.privilege_status === 3) {
            viewModel.hasUsedTipShow = true
            emit('report', { contentTitle: '9', contentIndex: 9 })
            return
          }
        }

        // 都没有
        toExaminationHome()
      }
    }

    function oldCheckExamPrivilege () {
      // 未登录
      if (!viewModel.loginStatus) {
        login()
        return
      }

      if (viewModel.privilege) {
        // 非会员或者不满足
        if (viewModel.privilege.privilege_status === 2) {
          emit('showExaminationPayModal')
          return
        }

        // 满足条件
        if (viewModel.privilege.privilege_status === 0) {
          toExamination()
        }
      }
    }

    function toExaminationHome () {
      client.common.API.client_openOptionWindow({
        url: `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/examination/home?from=36`,
        open_opction: 8
      })
      viewModel.hasUsedTipShow = false
    }

    function showHaohuoModal () {
      client.home.REPORT.reportHomeOperate({
        main_click: 47,
        user_login: viewModel.loginStatus ? 1 : 2
      })
      emit('showHaohuoModal')
    }

    async function sortIconList () {
      const { token, openId, loginStatus } = viewModel
      if (!loginStatus) {
        return
      }

      if (!viewModel.baseSortIconList) {
        viewModel.baseSortIconList = [...viewModel.iconList]
      }

      const { resp_common, data } = await getPrivilegeInfoApi({
        common: {
          token: token,
          open_id: openId
        },
        return_user_permission: 1
      })

      const userAllPermissionList = data?.user_all_permission_list
      if (resp_common?.ret === 0 && userAllPermissionList) {
        handleIconList(userAllPermissionList)
      }
    }

    function handleIconList (userAllPermissionList) {
      const permission = userAllPermissionList.split(',') || []
      const hasRightlist = []
      const noRightlist = []

      // 用户拥有的权限
      viewModel.permissionList = permission

      const sortList = [...viewModel.baseSortIconList]

      sortList.forEach(item => {
        const newItem = JSON.parse(JSON.stringify(item))
        newItem.method = item.method

        if (permission.indexOf(newItem.alias) !== -1) {
          hasRightlist.push(newItem)
        } else {
          if (newItem.alias == 'wechat-publicAccount-qr') {
            hasRightlist.push(newItem)
            return
          }

          newItem.noRight = true
          noRightlist.push(newItem)
        }
      })

      viewModel.iconList = hasRightlist.concat(noRightlist)
    }

    function resumeIconList () {
      viewModel.baseSortIconList && (viewModel.iconList = [...viewModel.baseSortIconList])
    }

    // 检查pdf开关
    function checkPdf () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'pdf2word',
        check_vip_version: 3
      }

      checkSwitchStatus(switchData)
    }
    // 检查隐私开关与ab测
    function checkYinsiSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'kprivacycleaner',
        check_vip_version: 1
      }

      checkSwitchStatus(switchData)
    }

    // 检查文件粉碎开关
    function checkRemoveFileSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'file_remove'
      }
      checkSwitchStatus(switchData)
    }

    // 检查系统盘瘦身开关
    function checkSystemSlimSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'system_slim'
      }
      checkSwitchStatus(switchData)
    }

    // 检查浏览器主页修复
    function checkHomepageFix () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'homepage_fix'
      }
      checkSwitchStatus(switchData)
    }

    // 检查文档修复开关
    function checkDocFix () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'docfix'
      }
      checkSwitchStatus(switchData)
    }

    // 检查文档卫士开关
    function checkDocProtect () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'docprotect'
      }
      checkSwitchStatus(switchData)
    }

    function checkSwitchStatus (switchData) {
      viewModel.interestsIntro.forEach(item => setSwitchStatus(item, switchData))

      viewModel.iconList.forEach(item => setSwitchStatus(item, switchData))

      if (viewModel.baseSortIconList) {
        viewModel.baseSortIconList.forEach(item => setSwitchStatus(item, switchData))
      }
    }

    function setSwitchStatus (item, switchData) {
      if (viewModel.vip_version > switchData.check_vip_version && item.key_name == switchData.key_name) {
        item.hide = false
      }
    }

    function openCleaner () {
      client_openKisProcess({
        name: 'kprcycleaner.exe',
        arg: {
          vipfrom: '3017',
        }
      })
    }

    function openFileRemove () {
      client_open_vip_box({
        app_name: 'file_remove'
      })
    }

    function openSystemSlim () {
      client_open_vip_box({
        app_name: 'system_slim'
      })
    }

    function toIntegralMall () {
      context.root.$router.push('/integral/mall')
    }

    function reportPerformace () {
      client.techMonitor.REPORT.fetmReportPerformance()
    }

    return {
      viewModel,
      interestsIntroShow,
      title,
      iconListShow,
      showMore,
      handleClickIconItem,
      toExaminationHome
    }
  }
})
</script>

<style lang="scss">
@import '@/assets/css/mixins.scss';
.interests {
  margin-top: 20px;
  .spread-btn {
    margin-top: 12px;
    width: 90px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    background: #dc320a;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    &:hover {
      background: #ff390b;
    }
    &:active {
      background: #c42c08;
    }
    &.is-disabled {
      background: #999 !important;
      cursor: not-allowed;
    }
  }
  .spread-center {
    .item-content {
      position: relative;
      padding-top: 26px;
    }
  }
  .is-used {
    display: inline-block;
    margin-top: 12px;
    line-height: 30px;
    color: #999;
    position: absolute;
    width: 190px;
  }
  .desc-tip {
    position: absolute;
    top: 14px;
    z-index: 2;
    left: 177px;
    width: 112px;
    height: 25px;
    /*background: url(~@/assets/images/diamond/1v1-tip2.png) no-repeat center*/
    /*  center;*/
  }
}
.interests-title {
  color: #393736;
  font-size: 20px;
  font-weight: normal;
  padding-left: 26px;
  .more {
    position: relative;
    width: 81px;
    height: 22px;
    box-sizing: border-box;
    display: inline-block;
    cursor: pointer;
    line-height: 20px;
    margin-right: 15px;
    color: #575757;
    font-size: 12px;
    text-align: left;
    text-indent: 8px;
    background-color: #f4f6fa;
    border: 1px solid #e4e5e9;
    border-radius: 11px;
    &:hover {
      color: #575757;
      border-color: #e4e5e9;
      background-color: #fff;
      i {
        background-position: -8px 0;
      }
    }
    &:active {
      color: #828282;
      border-color: #e7e7e7;
      background-color: #e7e7e7;
      i {
        background-position: -16px 0;
      }
    }
    i {
      position: absolute;
      top: 4px;
      right: 11px;
      width: 8px;
      height: 11px;
      background: url(~@/assets/images/twoDown.png) no-repeat 0 0;
    }
  }
}
.interests-list {
  padding-left: 9px;
  margin-top: 15px;
  margin-bottom: 10px;
  &.is-member {
    .interests-item {
      background: #fffbe9;
      border-color: #fdd63c;
    }
    .interests-item-no-right {
      background: #edf2f5;
      border-color: #c5d4dd;
      color: #777;
    }
  }
}
.interests-item {
  width: 92px;
  height: 120px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #31def2;
  background: #e8f9ff;
  color: #000005;
  font-size: 14px;
  float: left;
  margin-left: 17px;
  text-align: center;
  line-height: 1.2;
  border-radius: 4px;
  margin-bottom: 22px;
  cursor: pointer;
  &:hover {
    background: #ffebde !important;
    border-color: #de461e !important;
  }
  .item-pic {
    // width: 70px;
    // height: 58px;
    width: 64px;
    height: 64px;
    margin: 12px auto 8px;
    background: url(~@/assets/images/privileges.png) no-repeat;
  }

  .tip {
    position: absolute;
    top: -12px;
    left: -4px;
  }

  .item1 {
    background-position: -0px -0px;
  }

  .item2 {
    background-position: -64px -0px;
  }

  .item3 {
    background-position: -128px -0px;
  }

  .item6 {
    background: url(~@/assets/images/interest/pop-window.png) no-repeat center center ;
  }

  .item4 {
    background-position: -256px -0px;
  }

  .item7 {
    background-position: -320px -0px;
  }

  .item8 {
    background-position: -384px -0px;
  }

  .item9 {
    background-position: -448px -0px;
  }

  .item10 {
    background-position: -512px -0px;
  }

  .item13 {
    background-position: -0px -64px;
  }

  .item12 {
    background-position: -64px -64px;
  }

  .item11 {
    background-position: -128px -64px;
  }

  .item14 {
    background-position: -192px -64px;
  }

  .item15 {
    background-position: -256px -64px;
  }

  .item16 {
    background-position: -320px -64px;
  }

  .item17 {
    background-position: -255px -193px;
  }
  .item18 {
    background-position: -384px -193px;
  }
  .item19 {
    background-position: -128px -251px;
  }
  .item20 {
    background-position: 2px -253px;
  }
  .item21 {
    width: 79px;
    height: 79px;
    background: url(~@/assets/images/wechatpa-qrcode.png);
    margin-top: 9px;
  }
  .item22 {
    background-position: -257px -253px;
  }
  .item23 {
    background-position: -384px -253px;
  }
  .item24 {
    background-position: -512px -253px;
  }
  .item25 {
    background: url(~@/assets/images/interest/zip.png) center 12px no-repeat;
  }
  .item26 {
    background: url(~@/assets/images/interest/pdf.png) center 12px no-repeat;
  }
  .item27 {
    background: url(~@/assets/images/interest/ocr.png) center 12px no-repeat;
  }
  .item28 {
    background: url(~@/assets/images/interest/pdf-edit.png) center 12px no-repeat;
  }
  .item29 {
    background: url(~@/assets/images/interest/pdf-push-text.png) center 12px no-repeat;
  }
  .item30 {
    background: url(~@/assets/images/interest/pdf-push-img.png) center 12px no-repeat;
  }
  .item31 {
    background: url(~@/assets/images/interest/pdf-erase.png) center 12px no-repeat;
  }
  .item32 {
    background: url(~@/assets/images/interest/pdf-select-ocr.png) center 12px no-repeat;
  }
  .item33 {
    background: url(~@/assets/images/interest/pdf-remove-watermark.png) center 12px no-repeat;
  }
  .item34 {
    background: url(~@/assets/images/interest/batch-print.png) center 12px no-repeat;
  }
  .item35 {
    background: url(~@/assets/images/interest/invoice-printing.png) center 12px no-repeat;
  }
  .item36 {
    background: url(~@/assets/images/interest/translate.png) center 12px no-repeat;
  }

  .more {
    width: 64px;
    height: 64px;
    background-position: -384px -64px;
  }

  .item1-grey {
    background-position: -448px -64px;
  }

  .item2-grey {
    background-position: -512px -64px;
  }

  .item3-grey {
    background-position: -0px -128px;
  }

  .item4-grey {
    background-position: -64px -128px;
  }

  .item6-grey {
    background: url(~@/assets/images/interest/pop-window-grey.png) no-repeat center center ;
  }

  .item7-grey {
    background-position: -192px -128px;
  }

  .item8-grey {
    background-position: -256px -128px;
  }

  .item9-grey {
    background-position: -320px -128px;
  }

  .item10-grey {
    background-position: -384px -128px;
  }

  .item11-grey {
    background-position: -448px -128px;
  }

  .item12-grey {
    background-position: -512px -128px;
  }

  .item13-grey {
    background-position: -0px -192px;
  }
  .item14-grey {
    background-position: -192px -192px;
  }
  .item15-grey {
    background-position: -64px -192px;
  }

  .item16-grey {
    background-position: -128px -192px;
  }
  .item17-grey {
    background-position: -317px -193px;
  }
  .item18-grey {
    background-position: -448px -193px;
  }
  .item19-grey {
    background-position: -196px -251px;
  }
  .item20-grey {
    background-position: -66px -253px;
  }
  .item22-grey {
    height: 64px;
    background-position: -317px -253px;
  }
  .item23-grey {
    height: 64px;
    background-position: -445px -253px;
  }
  .item24-grey {
    width: 64px;
    height: 64px;
    background-position: -512px -189px;
  }
  .item25-grey {
    width: 64px;
    height: 64px;
    background: url(~@/assets/images/interest/zip-grey.png) center 12px no-repeat;
  }
  .item26-grey {
    width: 64px;
    height: 64px;
    background: url(~@/assets/images/interest/pdf-grey.png) center 12px no-repeat;
  }
  .item27-grey {
    width: 64px;
    height: 64px;
    background: url(~@/assets/images/interest/ocr-grey.png) center 12px no-repeat;
  }
  .item28-grey {
    background: url(~@/assets/images/interest/pdf-edit-grey.png) center 12px no-repeat;
  }
  .item29-grey {
    background: url(~@/assets/images/interest/pdf-push-text-grey.png) center 12px no-repeat;
  }
  .item30-grey {
    background: url(~@/assets/images/interest/pdf-push-img-grey.png) center 12px no-repeat;
  }
  .item31-grey {
    background: url(~@/assets/images/interest/pdf-erase-grey.png) center 12px no-repeat;
  }
  .item32-grey {
    background: url(~@/assets/images/interest/pdf-select-ocr-grey.png) center 12px no-repeat;
  }
  .item33-grey {
    background: url(~@/assets/images/interest/pdf-remove-watermark-grey.png) center 12px no-repeat;
  }
  .item34-grey {
    background: url(~@/assets/images/interest/batch-print-grey.png) center 12px no-repeat;
  }
  .item35-grey {
    background: url(~@/assets/images/interest/invoice-printing-grey.png) center 12px no-repeat;
  }
  .item36-grey {
    background: url(~@/assets/images/interest/translate-grey.png) center 12px no-repeat;
  }
}
.desc-list {
  li {
    margin-bottom: 8px;
    line-height: 1;
    color: #919eb2;
  }
}
.origin-list {
  list-style: disc;
  padding-left: 25px;
  li {
    list-style: disc;
  }
}
.tips {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-top: -80px;
  margin-left: -180px;
  width: 360px;
  height: 160px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  border: solid 1px #fac936;
  p {
    text-align: right;
    &.content {
      text-align: left;
      padding: 10px 30px;
      color: #636d78;
      font-size: 14px;
    }
    &.close {
      text-align: center;
    }
  }
  p::selection {
    background: #2196f3;
    color: #fff;
  }

  .btn_close {
    display: inline-block;
    z-index: 3;
    @include icon_bg;
    width: 26px;
    height: 26px;
    background-position: -5px -262px;
    cursor: pointer;
    margin-right: 5px;
    margin-top: 3px;
    &:hover {
      background-position: -29px -262px;
    }
  }
  .btn_login {
    display: inline-block;
    margin-top: 10px;
    outline: none;
    @include btn_class(
      $width: 120px,
      $height: 38px,
      $line-height: 38px,
      $font-size: 16px
    );
  }
  .copy-btn {
    cursor: pointer;
    color: #0000ff;
  }
  .copy-input {
    text-indent: -9999px;
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .tips-1v1 {
    color: #bbb;
    text-align: left;
    padding-left: 30px;
    font-size: 14px;
    padding-bottom: 10px;
    margin-top: -5px;
    line-height: 1;
  }
}

.tips-1v1-hasused {
  width: 400px;
  height: 180px;
  /*background: url(~@/assets/images/examination/home-used-tip.png) no-repeat*/
  /*  center center;*/
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-top: -90px;
  margin-left: -200px;
  padding-top: 73px;
  box-sizing: border-box;
  border: 1px solid #e4e4e4;
  p {
    font-size: 14px;
    color: #636d78;
    text-align: center;
  }
  .btn {
    background: #5cbf26;
    width: 90px;
    height: 30px;
    margin: 40px auto 0;
    line-height: 30px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 1px;
    cursor: pointer;
    &:hover {
      background: #70df33;
    }
    &:active {
      background: #4da51c;
    }
  }
  .close {
    position: absolute;
    right: 11px;
    top: 9px;
    width: 12px;
    height: 12px;
    background: url(~@/assets/images/tip-close.png) no-repeat left
      center;
    cursor: pointer;
    &:hover {
      background-position-x: center;
    }
    &:active {
      background-position-x: right;
    }
  }
}
</style>
